<template>

  <div class="container">
    <div class="row">


      <span class="col-12 text-center" v-if="podcasts.length < 1 && !isLoading" v-html="noResults"></span>
      <div class="col-md-4 mb-4"
           v-for="(podcast, index) in podcasts"
           v-if="podcasts.length > 0"
      >
        <a :href="podcast.href" class="card" :id="'podcast-' + podcast.id">
          <div class="card-img-top"
               v-lazy:background-image="podcast.cover_url"
          ></div>
          <div class="spinner-border" role="status">
            <span class="visually-hidden"></span>
          </div>
          <div class="card-body">
            <h5 class="card-title">{{podcast.title}}</h5>
            <div class="card-text">{{podcast.lead}}</div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">

      <div class="mx-auto">
        <div v-if="isLoading" class="text-center pt-5 pb-4 py-3">
          <loading-feedback :active="isLoading"></loading-feedback>
        </div>

        <div class="row pt-5 pb-4" v-if="!isLoading && currentPage < totalPages" >
          <a @click="getNewPage" class="btn btn-primary d-inline-block m-auto">{{$lang.get('pagination.loadmore')}}</a>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
    import Content from "../services/Content";
    import {DateTime} from "luxon";

    export default {
        props: [
            'max',
            'locale',
            'noResults',
            'profileSlug',
            'query',
        ],

        data: () => {
            return {
                podcasts: [],
                selectedPageType: null,
                currentPage: 1,
                totalPages: 1,
                searchFilter: '',
                isLoading: false,
            }
        },

        mounted: function () {
          this.fetchPodcasts();
        },

        methods: {
            fetchPodcasts: function () {
                this.isLoading = true;
                Content.FetchAllPodcasts(
                        this.currentPage,
                        this.max,
                        this.locale,
                        this.profileSlug,
                        this.query,
                ).then((res) => {
                        this.isLoading = false;
                        this.podcasts = this.podcasts.concat(res.data);
                        this.totalPages = res.meta.pagination.total_pages
                        this.$forceUpdate();
                    })
                    .catch((err) => {
                        this.isLoading = false;
                    })
            },

            getNewPage: function () {
              this.currentPage += 1;
              this.fetchPodcasts();
            },
        },
    }
</script>
